;(function() {
/* @ngInject */
function KontaktController(IndexService, $interval, $scope) {

  let vm = this;

  let server = IndexService;

  vm.agreement = false;

  vm.onSendClick = onSendClick;

  vm.contact = {
    phoneNumber: {
      prefix: "+421"
    }
  };

  function onSendClick() {
    if($scope.contact.$invalid) {
      vm.submitted = true;
    } else {
      if (vm.contact) {
        server.sendContactMail(vm.contact).then((data) => {
          vm.success = true;
          vm.contact = {};
          $scope.contact.$setUntouched();
          $interval(function () {
            vm.success = false;
          }, 2000, 1);
        });
      }
    }
  }

}

angular.module("firmaren")
  .controller("KontaktController", KontaktController);
}());
